// components/Header.tsx
import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Language } from '../types/language';

export const Header: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();

  const handleLanguageChange = (newLanguage: Language) => {
    setLanguage(newLanguage);
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-main">
          <h1>{t.appTitle}</h1>
          <p>{t.appSubtitle}</p>
        </div>
        
        <div className="language-switcher">
          <button 
            className={`lang-btn ${language === 'en' ? 'active' : ''}`}
            onClick={() => handleLanguageChange('en')}
            title="English"
          >
            🇺🇸 EN
          </button>
          <button 
            className={`lang-btn ${language === 'cs' ? 'active' : ''}`}
            onClick={() => handleLanguageChange('cs')}
            title="Čeština"
          >
            🇨🇿 CS
          </button>
        </div>
      </div>
    </header>
  );
};